import { SiteContext } from "@/context/SiteContext";
import useApi from "@/hooks/useApi";
import { Site } from "@/types";
import React, { useState } from "react";

export function SiteProvider(props: { children: React.ReactNode }) {
  const [site, setSite] = useState<Site>({
    siteId: 0,
    companyName: "unknown"
  });

  const api = useApi();

  React.useEffect(() => {
    async function load() {
      try {
        const response = await api.admin.get("api/SiteSettings");
        if (response.ok) {
          const siteData = await response.json();
          setSite(siteData);
        } else {
          console.error("Failed to load site data: HTTP", response.status);
        }
      } catch (error) {
        console.error("Failed to load site data:", error);
      }
    }

    load();
  }, [api]);

  return (
    <SiteContext.Provider value={{ site }}>
      {props.children}
    </SiteContext.Provider>
  );
}
